import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ID, RIGHT, LEFT, useExaminations, useCurrentExamination } from 'store/examinations';
import AnimateBox from 'components/AnimateBox';
import Message from 'components/Message';

import { handleItems } from './utils';
import { Item, DateText, Text } from './styles';

const History = ({ side, isOpened }) => {
  const examinations = useExaminations();
  const current = useCurrentExamination(ID);
  const items = useMemo(() => handleItems(examinations, current, side), [examinations, current, side]);

  return (
    <AnimateBox isOpen={isOpened}>
      {items.length ? (
        items.map(({ id, value, date }) => (
          <Item key={id}>
            <DateText>{date}</DateText>
            <Text>{value}</Text>
          </Item>
        ))
      ) : (
        <Message form={1} textAlign="center">
          Keine Historie
        </Message>
      )}
    </AnimateBox>
  );
};

History.propTypes = {
  side: PropTypes.oneOf([RIGHT, LEFT]).isRequired,
  isOpened: PropTypes.bool.isRequired,
};

export default History;
